import {FlatList, Image, Text, TouchableOpacity, View} from 'react-native';
import React, {useEffect, useState} from 'react';
import {createStyles} from '../../utils/createStyles';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {
  fetchBookVersions,
  fetchGrades,
  fetchQuestions,
  fetchSubjects,
  selectBookVersions,
  selectGrades,
  selectSubjects,
  Subject,
} from '../../store/xueke';
import OverlaySelect from './components/selectGrade';
import {
  getXkwCoursesKnowledgePointsLiteTree,
  getXkwTextbooksCatalogTree,
  updateXkwInfo,
  UpdateXkwInfoParams,
} from '../../API/mylearn';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../components/Loading/GlobalLoading';
import Toast from 'react-native-toast-message';
import {useNavigation} from '@react-navigation/native';
import {getUserInfo, selectUserInfo} from '../../store/user';

const SynchroWorkbook = () => {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const subjects = useAppSelector(selectSubjects);
  // const userInfo = useAppSelector(selectUserInfo);
  const grades = useAppSelector(selectGrades);
  const versions = useAppSelector(selectBookVersions);
  const userInfo = useAppSelector(selectUserInfo); // 用户信息
  const [currentSubjectId, setCurrentSubjectId] = useState(0);
  const [currentType, setCurrentType] = useState(1);
  const [visible, setVisible] = useState(false);
  const [selectedValue, setSelectedValue] = useState<any[]>([]);
  const [updateBasicInfoObjState, setUpdateBasicInfoObjState] = useState(true);
  const toggleOverlay = () => {
    setVisible(!visible);
    // StatusBar.setHidden(true);
  };
  const [basicInfoObj, setBasicInfoObj] = useState<UpdateXkwInfoParams>({});
  const [basicInfoName, setBasicInfoName] = useState('请选择教材版本');
  const handleButtonPress = (
    title: string,
    basicInfo: {grade_id: number; term: string; version_id: number},
  ) => {
    console.log(title, basicInfo);
    // setBasicInfoName(title);
    dispatch(fetchSubjects(basicInfo.grade_id));
    setVisible(false);
    updatePreferences({
      grade_id: basicInfo.grade_id,
      term: basicInfo.term,
      subject_id: currentSubjectId,
      version_id: basicInfo.version_id,
    });
  };
  // 更新偏好设置
  const updatePreferences = async (data: UpdateXkwInfoParams) => {
    console.log('更新偏好设置', data);
    try {
      const res = await updateXkwInfo(data);
      console.log('res111', res);
      if (res.status === 200) {
        setBasicInfoObj({
          subject_id: currentSubjectId,
          grade_id: res.data.xkwGradeId,
          term: res.data.xkwTerm,
          version_id: data.version_id,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
  // 初始化加载
  const initBasicInfo = async () => {
    setUpdateBasicInfoObjState(true);
    showGlobalLoading({text: '加载中'});
    await dispatch(fetchGrades()).unwrap(); // 获取所有年级
    dispatch(getUserInfo()) // 获取用户信息
      .unwrap()
      .then(res => {
        console.log(res);
        const grade_id = res.xkwGradeId
          ? res.xkwGradeId
          : res.grade
          ? res.grade
          : 0;
        const term = res.xkwTerm ? res.xkwTerm : 'LAST';
        dispatch(fetchSubjects(grade_id)) // 通过用户年级获取科目列表
          .unwrap()
          .then(async sub => {
            console.log('sub', sub);

            const subject_id = sub[0].id;

            const version_id = await getVersionId(grade_id, subject_id);
            setBasicInfoObj(prevBasicInfoObj => ({
              ...prevBasicInfoObj,
              grade_id: grade_id,
              term,
              version_id,
              subject_id,
            }));
            changeSubject(subject_id);
            setUpdateBasicInfoObjState(false);
            // });
          });
      });
  };
  useEffect(() => {
    initBasicInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 修改科目
  const changeSubject = (id: number) => {
    setCurrentSubjectId(id);
  };
  // 根据用户的信息获取树状结构
  useEffect(() => {
    console.log('basicInfoObjChange', basicInfoObj);
    if (updateBasicInfoObjState) {
      return;
    }
    if (!basicInfoObj.subject_id) {
      return;
    }
    // initBasicInfo();
    if (currentType === 1) {
      getChapterTree(); // 获取章节树
    } else {
      // 类型为知识点
      getKnowledgeTree(); // 获取知识点树
    }

    const gradeName = grades.find(
      item => item.id === basicInfoObj.grade_id,
    )?.name;
    const termName = basicInfoObj.term === 'LAST' ? '上学期' : '下学期';
    console.log('versions', versions, basicInfoObj.version_id);
    // if (versions.length === 0) {
    //   Toast.show({
    //     type: 'error',
    //     text1: '该年级暂无教材版本',
    //   });
    //   return;
    // }

    // const versionName = '';
    const version = versions.find(i => i.id === basicInfoObj.version_id);
    const versionName = version ? version.name : versions[0].name;
    console.log(
      'setBasicInfoName',
      `${versionName}    |   ${gradeName} ${termName}`,
    );

    setBasicInfoName(`${versionName}    |   ${gradeName} ${termName}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basicInfoObj, currentType]);

  // 判断是否存在值，存在则返回值，不存在则返回默认值
  const getVersionId = (grade_id: number, subject_id: number) => {
    return dispatch(
      fetchBookVersions({
        gradeId: grade_id,
        subjectId: subject_id,
      }),
    )
      .unwrap()
      .then(res => {
        console.log('res', grade_id, subject_id, res);
        const list = userInfo.xkwCoursesTextbookVersionsList;
        const version =
          list !== undefined &&
          list.find(
            item =>
              item.grade_id === grade_id && item.subject_id === subject_id,
          );
        if (version) {
          return version.version_id;
        } else {
          return res[0].id;
        }
      });
  };

  // 科目修改时重新获取版本和tree
  useEffect(() => {
    console.log(currentSubjectId);
    if (basicInfoObj.grade_id != null) {
      getVersionId(basicInfoObj.grade_id, currentSubjectId).then(res => {
        setBasicInfoObj(prevState => {
          return {
            ...prevState,
            version_id: res,
            subject_id: currentSubjectId,
          };
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSubjectId]); // 当前科目或类型发生改变时触发;
  //  树结构
  const [chapterTree, setChapterTree] = useState([]); // [

  // 获取章节树
  const getChapterTree = async () => {
    initTreeProps();
    showGlobalLoading({text: '加载中'});
    const res = await getXkwTextbooksCatalogTree(basicInfoObj);
    console.log('res', res.data);
    if (res.status === 200) {
      hideGlobalLoading();
      if (res.data.length > 0) {
        setChapterTree(res.data[0].children);
      } else {
        setChapterTree([]);
      }
    } else {
      hideGlobalLoading();
    }
  };
  // 获取知识点
  const getKnowledgeTree = async () => {
    showGlobalLoading({text: '加载中'});
    setChapterTree([]);
    try {
      initTreeProps();
      const p = {
        grade_id: basicInfoObj.grade_id,
        subject_id: currentSubjectId,
        tags: 'STANDARD,CONTEST',
      };
      const res = await getXkwCoursesKnowledgePointsLiteTree(p);
      setChapterTree(res.data[0].children);
    } catch (e) {
      console.log(e);
    } finally {
      hideGlobalLoading();
    }
  };
  // 章节知识点切换
  const changeType = (type: number) => {
    setCurrentType(type);
    if (type === 1) {
      getChapterTree();
    } else {
      getKnowledgeTree();
    }
  };

  const renderItem = ({item}: {item: Subject}) => (
    <TouchableOpacity
      activeOpacity={1}
      onPress={() => changeSubject(item.id)}
      style={styles.SynchroWorkbookBoxTopItem}>
      <Text
        style={[
          styles.SynchroWorkbookBoxTopItemText,
          item.id === currentSubjectId &&
            styles.SynchroWorkbookBoxTopItemTextActive,
        ]}>
        {item.name}
      </Text>
      {item.id === currentSubjectId && (
        <Image
          style={styles.SynchroWorkbookBoxTopItemLine}
          source={{
            uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/swk_line.png',
          }}
        />
      )}
    </TouchableOpacity>
  );
  const imageSeparator = () => (
    <View style={styles.imageSeparator}>
      <Text>|</Text>
    </View>
  );
  const [itemsExpanded, setItemsExpanded] = useState<any>({});
  const [currentId, setCurrentId] = useState(null); // 当前展开的id
  const initTreeProps = () => {
    setItemsExpanded({});
    setCurrentId(null);
    setSelectedValue([]);
  };
  const handleItemClick = (id: string | number) => {
    setItemsExpanded({...itemsExpanded, [id]: !itemsExpanded[id]});
  };

  const RecursiveComponent = ({item, level}: {item: any; level: any}) => {
    const handlePress = () => {
      handleItemClick(item.id);
    };
    const handlePressItem = () => {
      if (selectedValue.length === 10) {
        Toast.show({
          type: 'error',
          text1: '最多选择10个' as string,
        });
        return;
      }
      if (selectedValue.filter(i => i.id === item.id).length > 0) {
        return;
      }
      // if (
      //   currentType === 2 &&
      //   selectedValue.filter(i => i.id === item.root_id).length > 0
      // ) {
      //   Toast.show({
      //     type: 'error',
      //     text1: '已勾选上一级  ' as string,
      //   });
      //   return;
      // }
      setSelectedValue([...selectedValue, {id: item.id, name: item.name}]);
    };
    return (
      <View>
        <View
          style={[
            styles.SWBBoxConLeftConItemChild,
            {marginLeft: 25 * (level - 2)},
          ]}>
          {item?.children?.length > 0 ? (
            <TouchableOpacity onPress={handlePress}>
              <Image
                style={styles.SWBBoxConLeftConItemJiajian}
                source={{
                  uri: itemsExpanded[item.id]
                    ? 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_jian.png'
                    : 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_add.png',
                }}
              />
            </TouchableOpacity>
          ) : (
            <View style={styles.SWBBoxConLeftConItemJiajian} />
          )}
          <TouchableOpacity onPress={() => handlePressItem()}>
            <Text style={styles.SWBBoxConLeftConItemChildText}>
              {item.name}
            </Text>
          </TouchableOpacity>
        </View>
        {itemsExpanded[item.id] &&
          item?.children?.map((child: {id: React.Key | null | undefined}) => (
            <RecursiveComponent key={child.id} item={child} level={level + 1} />
          ))}
      </View>
    );
  };
  const handleFirstLevelClick = (id: React.SetStateAction<null>) => {
    setCurrentId(id === currentId ? null : id);
  };
  const FirstLevelItem = ({item, index}: any) => {
    // 点击只处理第一级，更新currentId状态
    const handlePress = () => {
      handleFirstLevelClick(item.id);
    };
    const handlePressItem = () => {
      if (selectedValue.length === 10) {
        Toast.show({
          type: 'error',
          text1: '最多选择10个' as string,
        });
        return;
      }
      if (selectedValue.filter(i => i.id === item.id).length > 0) {
        return;
      }
      setSelectedValue([...selectedValue, {id: item.id, name: item.name}]);
    };
    return (
      <View
        style={[
          styles.SWBBoxConLeftConItemBox,
          index === 0 && {borderTopLeftRadius: 0},
        ]}>
        <View style={[styles.SWBBoxConLeftConItem]}>
          <TouchableOpacity
            style={{flex: 1}}
            onPress={handlePressItem}
            activeOpacity={1}>
            <Text style={styles.SWBBoxConLeftConItemText}>{item.name}</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={{
              height: '100%',
              width: 40,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
              flexShrink: 1,
            }}
            onPress={handlePress}
            activeOpacity={1}>
            <Image
              style={styles.SWBBoxConLeftConItemJT}
              source={{
                uri:
                  currentId === item.id
                    ? 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_top.png'
                    : 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_down.png',
              }}
            />
          </TouchableOpacity>
        </View>

        {currentId === item.id &&
          item?.children?.map((child: {id: React.Key | null | undefined}) => (
            <RecursiveComponent key={child.id} item={child} level={2} />
          ))}
      </View>
    );
  };

  const ChapterList = ({data}: any) => (
    <FlatList
      data={data}
      keyExtractor={item => item.id.toString()}
      renderItem={({item, index}) => (
        <FirstLevelItem key={index} index={index} item={item} />
      )}
    />
  );

  async function submitExercise() {
    let params;
    if (currentType === 1) {
      if (selectedValue.length === 0) {
        Toast.show({
          type: 'error',
          text1: '请选择章节' as string,
        });
        return;
      }
      params = {
        kpoint_ids: [],
        catalog_ids: selectedValue.map(item => item.id),
      };
    } else {
      if (selectedValue.length === 0) {
        Toast.show({
          type: 'error',
          text1: '请选择知识点' as string,
        });
        return;
      }
      params = {
        kpoint_ids: selectedValue.map(item => item.id),
        catalog_ids: [],
      };
    }
    const p = {
      grade_id: basicInfoObj.grade_id,
      subject_id: currentSubjectId,
      sceneType: '',
      difficulty_levels: [],
      formula_pic_format: '',
      en_word_ids: [],
      ...params,
    };
    console.log(p);
    showGlobalLoading({text: '加载中'}); // 显示加载提示
    dispatch(fetchQuestions(p))
      .unwrap()
      .then(res => {
        console.log(res);
        if (res) {
          // @ts-ignore
          navigation && navigation.navigate('WorkbookDetails', p); // 跳转到目标页面
        }
      })
      .catch(() => {
        // console.error(error); // 打印错误
        // 可以在这里添加任何你需要的错误处理逻辑
      })
      .finally(() => {
        hideGlobalLoading(); // 关闭加载提示
      });
  }

  // @ts-ignore
  return (
    <>
      <View style={styles.SynchroWorkbookBox}>
        <View style={styles.SynchroWorkbookBoxTop}>
          <FlatList
            data={subjects}
            renderItem={renderItem}
            ItemSeparatorComponent={imageSeparator}
            horizontal={true} // 设置为横向展示
          />
        </View>
        <View style={styles.SynchroWorkbookBoxCon}>
          <View style={styles.SynchroWorkbookBoxConLeft}>
            <View style={styles.SWBBoxConLeftTop}>
              <TouchableOpacity
                activeOpacity={1}
                onPress={() => changeType(1)}
                style={[
                  styles.SWBBoxConLeftTopBtn,
                  currentType === 1 && styles.SWBBoxConLeftTopActive,
                ]}>
                <Text
                  style={[
                    styles.SWBBoxConLeftTopBtnText,
                    currentType === 1 && styles.SWBBoxConLeftTopBtnTextActive,
                  ]}>
                  章节
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                activeOpacity={1}
                onPress={() => changeType(2)}
                style={[
                  styles.SWBBoxConLeftTopBtn,
                  styles.SWBBoxConLeftTopRight,
                  currentType === 2 && styles.SWBBoxConLeftTopActive,
                ]}>
                <Text
                  style={[
                    styles.SWBBoxConLeftTopBtnText,
                    currentType === 2 && styles.SWBBoxConLeftTopBtnTextActive,
                  ]}>
                  知识点
                </Text>
              </TouchableOpacity>
            </View>
            <View style={styles.SWBBoxConLeftCon}>
              <ChapterList data={chapterTree} />
            </View>
          </View>
          <View style={styles.SynchroWorkbookBoxConRight}>
            <View style={styles.SynchroWorkbookBoxConRightTop}>
              <TouchableOpacity
                onPress={toggleOverlay}
                style={[styles.SynchroWorkbookBoxConRightTopBox]}>
                <Text style={styles.SynchroWorkbookBoxConRightTopBoxText}>
                  {basicInfoName}
                </Text>
              </TouchableOpacity>
              <OverlaySelect
                isVisible={visible}
                subjectId={currentSubjectId}
                userInfo={userInfo}
                basicInfoObj={basicInfoObj}
                onBackdropPress={toggleOverlay}
                onButtonPress={(title, basicInfo) =>
                  handleButtonPress(title, basicInfo)
                }
              />
            </View>
            <View style={styles.SynchroWorkbookBoxConRightBox}>
              {/*<View style={styles.SWBBoxConRightBoxMB}>*/}
              {/*  <Text style={styles.SWBBoxConRightBoxTitle}>选择学习目标</Text>*/}
              {/*  <View style={styles.SWBBoxConRightBoxMBCon}>*/}
              {/*    {targetList.map(item => (*/}
              {/*      <TouchableOpacity*/}
              {/*        activeOpacity={1}*/}
              {/*        onPress={() => setCurrentTargetId(item.id)}*/}
              {/*        style={[*/}
              {/*          styles.SWBBoxConRightBoxMBConItem,*/}
              {/*          item.id === currentTargetId &&*/}
              {/*            styles.SWBBoxConRightBoxMBConItemActive,*/}
              {/*        ]}*/}
              {/*        key={item.id}>*/}
              {/*        <Text*/}
              {/*          style={[*/}
              {/*            styles.SWBBoxConRightBoxMBConItemText,*/}
              {/*            item.id === currentTargetId &&*/}
              {/*              styles.SWBBoxConRightBoxMBConItemTextActive,*/}
              {/*          ]}>*/}
              {/*          {item.name}*/}
              {/*        </Text>*/}
              {/*      </TouchableOpacity>*/}
              {/*    ))}*/}
              {/*  </View>*/}
              {/*</View>*/}
              <View style={styles.SWBBoxConRightBoxFW}>
                <Text style={styles.SWBBoxConRightBoxTitle}>选择学习范围</Text>
                <View style={styles.SWBBoxConRightBoxFWCon}>
                  {selectedValue.map(item => (
                    <View
                      key={'select' + item.id}
                      style={styles.SWBBoxConRightBoxFWConItem}>
                      <Text style={styles.SWBBoxConRightBoxFWConItemText}>
                        {item.name}
                      </Text>
                      <TouchableOpacity
                        onPress={() => {
                          setSelectedValue(
                            selectedValue.filter(i => i.id !== item.id),
                          );
                        }}>
                        <Image
                          style={styles.SWBBoxConRightBoxFWConImg}
                          source={{
                            uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/myLearn_close.png',
                          }}
                        />
                      </TouchableOpacity>
                    </View>
                  ))}
                </View>
              </View>
              <View style={styles.SWBBoxConRightBoxBtn}>
                <TouchableOpacity
                  style={styles.SWBBoxConRightBoxBtnSubmit}
                  onPress={submitExercise}>
                  <Text style={styles.SWBBoxConRightBoxBtnSubmitText}>
                    生成练习
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};
const styles = createStyles({
  SynchroWorkbookBox: {
    flex: 1,
    backgroundColor: '#EAF1FF',
    paddingHorizontal: '2.3rem',
    paddingBottom: '2.3rem',
  },
  SynchroWorkbookBoxTop: {
    flexDirection: 'row',
  },
  SynchroWorkbookBoxTopItem: {
    minWidth: '12.2rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: '1.2rem',
    paddingHorizontal: '1.5rem',
  },
  SynchroWorkbookBoxTopItemText: {
    fontSize: '1.6rem',
    color: '#7D7A95',
  },
  SynchroWorkbookBoxTopItemTextActive: {
    zIndex: 2,
    color: '#6658FF',
    fontSize: '1.9rem',
    fontWeight: 'bold',
  },
  SynchroWorkbookBoxTopItemLine: {
    zIndex: 1,
    marginTop: '-1.2rem',
    width: '5.7rem',
    height: '1.25rem',
  },
  imageSeparator: {
    // width: '1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  // con
  SynchroWorkbookBoxCon: {
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    marginTop: '1.8rem',
  },
  SynchroWorkbookBoxConLeft: {
    width: '30%',
    maxWidth: '39.8rem',
    flexShrink: 1,
    marginRight: '1.5rem',
  },
  SWBBoxConLeftTop: {
    flexDirection: 'row',
    marginTop: '0.5rem',
    // marginBottom: '2.97rem',
  },
  SWBBoxConLeftTopBtn: {
    width: '8rem',
    height: '3.35rem',
    backgroundColor: '#D5E1FA',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopLeftRadius: '1rem',
    borderTopRightRadius: '1rem',
    zIndex: 3,
  },
  SWBBoxConLeftTopBtnText: {
    color: '#847DD6',
    fontSize: '1.35rem',
  },
  SWBBoxConLeftTopBtnTextActive: {
    color: '#ffffff',
  },
  SWBBoxConLeftTopActive: {
    backgroundColor: '#6658FF',
    zIndex: 4,
  },

  SWBBoxConLeftTopRight: {
    width: '10rem',
    marginLeft: '-1.4rem',
  },
  SWBBoxConLeftCon: {
    flex: 1,
  },
  SWBBoxConLeftConItemBox: {
    minHeight: '4rem',
    backgroundColor: '#fff',
    marginBottom: '1.5rem',
    borderRadius: '1rem',
  },
  SWBBoxConLeftConItem: {
    width: '100%',
    minHeight: '4rem',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: '2rem',
    justifyContent: 'space-between',
  },
  SWBBoxConLeftConItemText: {
    color: '#3D3D3D',
    fontSize: '1.4rem',
    fontWeight: '500',
  },
  SWBBoxConLeftConItemJT: {
    width: '1.65rem',
    height: '1.2rem',
  },
  SWBBoxConLeftConItemChild: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: '2.15rem',
    marginBottom: '.75rem',
  },
  SWBBoxConLeftConItemChildText: {
    fontSize: '1.25rem',
    color: '#3D3D3D',
  },
  SWBBoxConLeftConItemJiajian: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '.7rem',
  },
  SynchroWorkbookBoxConRight: {
    flex: 1,
  },
  SynchroWorkbookBoxConRightTop: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: '.9rem',
  },
  SynchroWorkbookBoxConRightTopBox: {
    minWidth: '14.75rem',
    height: '3rem',
    backgroundColor: '#fff',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.75rem',
    paddingHorizontal: '1rem',
    zIndex: 999999,
  },
  SynchroWorkbookBoxConRightTopBoxText: {
    fontSize: '1.1rem',
    color: '#64617B',
  },
  SynchroWorkbookBoxConRightBox: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: '1rem',
    paddingHorizontal: '2rem',
    paddingVertical: '1.65rem',
  },
  SWBBoxConRightBoxTitle: {
    color: '#3D3D3D',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginRight: '2.35rem',
  },
  SWBBoxConRightBoxMB: {
    marginBottom: '1rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  SWBBoxConRightBoxMBCon: {
    flexDirection: 'row',
  },
  SWBBoxConRightBoxMBConItem: {
    width: '8.5rem',
    height: '3.2rem',
    backgroundColor: '#EAF1FF',
    marginRight: '2.5rem',
    borderRadius: '1.6rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  SWBBoxConRightBoxMBConItemText: {
    fontWeight: '500',
    fontSize: '1.35rem',
    color: '#3D3D3D',
  },
  SWBBoxConRightBoxMBConItemActive: {
    backgroundColor: '#6658FF',
  },
  SWBBoxConRightBoxMBConItemTextActive: {
    color: '#FFFFFF',
  },
  SWBBoxConRightBoxFW: {
    flex: 1,
    flexDirection: 'column',
    marginBottom: '1.75rem',
  },
  SWBBoxConRightBoxFWCon: {
    marginTop: '.9rem',
    flex: 1,
    width: '100%',
    backgroundColor: '#F4F7FF',
    borderRadius: '1rem',
    paddingHorizontal: '1.65rem',
    paddingVertical: '1.5rem',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  SWBBoxConRightBoxFWConItem: {
    flexDirection: 'row',
    alignItems: 'center',
    height: '3.2rem',
    backgroundColor: '#fff',
    borderWidth: 1,
    borderRadius: '0.75rem',
    borderColor: '#B9B2FF',
    paddingLeft: '1.4rem',
    paddingRight: '0.95rem',
    marginRight: '1rem',
    marginBottom: '1rem',
  },
  SWBBoxConRightBoxFWConItemText: {
    color: '#6658FF',
    fontSize: '1.35rem',
  },
  SWBBoxConRightBoxFWConImg: {
    width: '1.4rem',
    height: '1.4rem',
    marginLeft: '1rem',
  },
  SWBBoxConRightBoxBtn: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  SWBBoxConRightBoxBtnSubmit: {
    width: '16.35rem',
    height: '4.2rem',
    borderWidth: 1,
    borderColor: '#6658FF',
    borderRadius: '2.1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  SWBBoxConRightBoxBtnSubmitText: {
    fontSize: '1.35rem',
    color: '#6658FF',
    fontWeight: '500',
  },
});
export default SynchroWorkbook;
